import React from "react";





export default function Footer() {
    return(
        // <div className="header_container">
        //     <div className="header">
        //         <div className="headerLogo">
        //             <h1>MEMORY</h1>
        //         </div>
        <div className="list">
            <div className="header footer" style={{display:'flex', justifyContent:'center'}}>
                <div className="headerLogo">
                    <h1><a target="_blank" rel="noreferrer" href="https://makosphoto.netlify.app/">Made by Mako</a></h1>
                </div>
            </div>
        </div>
        //     </div>
        // </div>
    )
}